<template>
  <v-container fill-height fluid>
    <v-layout wrap justify-center align-center>
      <v-flex column lg8 align-self-center class="mb-5">
        <material-card
          icon="mdi-calendar-star"
          color="indigo"
          :title="$t('Pages.CollectiveVacations.add_new')"
          :text="$t('Common.enter_details')">
          <v-card-text>
            <collective-vacation-form @save="add" :collective-vacation="collectiveVacation"></collective-vacation-form>
          </v-card-text>
        </material-card>
      </v-flex>
      <v-flex xs12 md5>
        <check-users-table @refresh="getUsers" :total="total" :items="users" :selected="selected" :loading="loading" @select="onSelect"></check-users-table>
      </v-flex>
      <v-flex xs12 md6 offset-md1>
        <attending-users-table :overtime="item" :total="selected.length" :items="selected" :loading="loading" @delete="onDelete" @update="syncUsers"></attending-users-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import CollectiveVacationForm from './Form'
    import AttendingUsersTable from './AttendingUsersTable'
    import CheckUsersTable from '../scheduledOvertime/CheckUsersTable'
export default {
  components: {CollectiveVacationForm, CheckUsersTable, AttendingUsersTable},
  data: () => ({
    collectiveVacation: {},
    users: [],
    loading: false,
    total: 0,
    pagination: {},
    selected: [],
  }),
  computed: {
  },
  created () {
  },
  methods: {
      add(data){
          data.selected = this.selected.map(user => user.id);
          this.repositories.collectiveVacation.store(data).then((response) => {
              this.$toast.success(response.data.message);
              this.collectiveVacation = {};
          });
      },
      getUsers(data = null){
        this.pagination = data;
        this.loading = true;
        this.repositories.user.searchBySector(data, 'sectors').then(response => {
          this.users = response.data.data;
          this.total = response.data.meta.pagination.total;
          this.updateSelected();
        }).finally(() => {
          this.loading = false;
        });
      },
    onSelect(selected){
      this.selected = selected;
      this.updateSelected();
    },
    updateSelected(){
      let result = _.map(this.users, item => {
        item.selected = false;
        return item;
      });

      this.users = result;

      for(var i = 0; i < this.users.length; i++){
        let user = this.users[i];
        if(_.find(this.selected, (item) => {
          return item.id == user.id;
        })){
          this.users[i].selected = true;
        }
      }
    },
    onDelete(id){
      _.remove(this.selected, function (currentObject) {
        return currentObject.id === id;
      });

      this.updateSelected();
    },
  }
}
</script>

<style lang="scss">

</style>
